import script from "./ChatsRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatsRadio.vue?vue&type=script&setup=true&lang=ts"

import "./ChatsRadio.vue?vue&type=style&index=0&id=9f31896a&lang=scss&scoped=true"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f31896a"]])

export default __exports__